let initialState = {
  friends: [
    { name: 'Mark', avatar: 'https://johannesippen.com/img/blog/humans-not-users/header.jpg', link: '/mark' },
    { name: 'Alex', avatar: 'https://johannesippen.com/img/blog/humans-not-users/header.jpg', link: '/alex' },
    { name: 'Jinny', avatar: 'https://johannesippen.com/img/blog/humans-not-users/header.jpg', link: '/jinny' }
  ]
}

const sidebarReducer = (state = initialState, action) => {

  return state;
}

export default sidebarReducer;